import React                from "react";
import Store                from "Dashboard/Core/Store";
import Navigate             from "Dashboard/Core/Navigate";
import useForm              from "Dashboard/Hooks/Form";

// Components
import AuthContainer        from "Components/Utils/Auth/AuthContainer";
import AuthHeader           from "Components/Utils/Auth/AuthHeader";
import AuthForm             from "Components/Utils/Auth/AuthForm";

// Dashboard
import InputField           from "Dashboard/Components/Form/InputField";



/**
 * The Code Page
 * @returns {React.ReactElement}
 */
function CodePage() {
    const { verifyReset } = Store.useAction("auth");

    const navigate = Navigate.useGoto();


    // The Initial Data
    const initialData = {
        resetCode : "",
    };

    // Handles the Edit
    const handleEdit = async (data) => {
        await verifyReset(data);
        navigate("PASS_RESET", data.resetCode);
    };

    // The Form State
    const {
        loading, data, errors, handleChange, handleSubmit,
    } = useForm("resetCode", initialData, handleEdit, null, false);



    // Do the Render
    return <AuthContainer>
        <AuthHeader
            title="CODE_TITLE"
            help="CODE_HELP"
        />
        <AuthForm
            url="LOGIN"
            link="CODE_ACCOUNT"
            button="CODE_BUTTON"
            error={errors.form}
            onSubmit={handleSubmit}
            isLoading={loading}
        >
            <InputField
                name="resetCode"
                label="GENERAL_CODE"
                value={data.resetCode}
                error={errors.resetCode}
                onChange={handleChange}
                isRequired
            />
        </AuthForm>
    </AuthContainer>;
}

export default CodePage;
